var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { KeyValueStorage as _KeyValueStorage } from '../KeyValueStorage';
import { SQLiteObject } from '@awesome-cordova-plugins/sqlite/ngx';
import * as i0 from "@angular/core";
export * from "@awesome-cordova-plugins/sqlite/ngx";
var KeyValueStorage = /** @class */ (function (_super) {
    __extends(KeyValueStorage, _super);
    function KeyValueStorage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeyValueStorage.prototype.sqliteCreate = function (encryptionKey) {
        return __awaiter(this, void 0, void 0, function () {
            var db;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.database === null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, (function (config) {
                                return new Promise(function (resolve, reject) {
                                    window.sqlitePlugin.openDatabase(config, function (db) { return resolve(new SQLiteObject(db)); }, function (err) {
                                        console.log('error opening database', err);
                                        reject(err);
                                    });
                                });
                            })({
                                name: this.databaseName,
                                location: 'default',
                                key: encryptionKey
                            })];
                    case 1:
                        db = _a.sent();
                        this.database = db;
                        return [3 /*break*/, 3];
                    case 2: throw new Error('Storage already created');
                    case 3: return [2 /*return*/, new Promise(function (resolve, reject) {
                            try {
                                _this.database.executeSql("CREATE TABLE IF NOT EXISTS " + _this.tableName + "(id INTEGER PRIMARY KEY, key unique, value)", [], function () {
                                    resolve();
                                }, function (error) {
                                    reject(error);
                                });
                            }
                            catch (e) {
                                var msg = e.message;
                                if (msg === 'Could not open database') {
                                    msg = 'Your encryption key may be invalid';
                                }
                                reject('Unable to initialize storage: ' + msg);
                            }
                        })];
                }
            });
        });
    };
    KeyValueStorage.prototype.sqliteDestroyStorage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (_this.database !== null) {
                            _this.database.close(function () {
                                _this.database = null;
                                window.sqlitePlugin.deleteDatabase({
                                    name: _this.databaseName,
                                    location: 'default'
                                }, function () {
                                    resolve();
                                }, function (err) {
                                    reject(err);
                                });
                            }, function (err) {
                                reject(err);
                            });
                        }
                        else {
                            reject('Storage not created');
                        }
                    })];
            });
        });
    };
    KeyValueStorage.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: KeyValueStorage, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
    KeyValueStorage.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: KeyValueStorage });
    return KeyValueStorage;
}(_KeyValueStorage));
export { KeyValueStorage };
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: KeyValueStorage, decorators: [{
            type: Injectable
        }] });
